export default "__VITE_ASSET__lJ8gFUbE__"